import { css } from "lit";

export const formStyles = css`
  form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: var(--wa-space-m);
  }

  wa-button[type="submit"] {
    align-self: start;
  }
`;
